<template>
    <div class="content">
        <Header :noFaq="true"></Header>
        <div class="contain">
            <studentBG></studentBG>
            <div v-if="isFirst" style="flex: 1; padding: 2vw 8vw">
                <firstBox :detail="detail" :isFirst.sync="isFirst"></firstBox>
            </div>
            <div v-else-if="detail.id" style="width: 100%; flex: 1">
                <modeHeader v-show="$route.path != '/adventure' && $route.path != '/assessment'" :detail="detail" @getProfile="getProfile" ref="modeHeader" @gradeChange="gradeChange"></modeHeader>
                <router-view v-if="$route.path != '/adventure'" :detail.sync="detail" @getProfile="getProfile" @reload="reload" />
                <!-- 防止跳转后重新渲染 -->
                <iframe
                    :class="$route.path == '/adventure' ? '' : 'notAdventure'"
                    :style="{ visibility: $route.path == '/adventure' ? '' : 'hidden' }"
                    ref="iframe"
                    style="width: 100%; height: 100%; border: none; display: block"
                    :src="url"
                    @load="deliverToken"
                />
            </div>
        </div>
        <PracticepreDialog v-if="teachingSwitch" :showDate="showDate" @closeDialog="teachingSwitch = false" :isAdventure="true"></PracticepreDialog>
    </div>
</template>

<script>
import Header from "@/layout/Header";
import studentBG from "./components/studentBG";
import firstBox from "./components/firstEnter";
// import assessment from "./components/assessment";
import modeHeader from "@/components/modeHeader";
import { getProfile } from "@/api/user";
import { setUserInfo, getUserInfo } from "@/utils/auth";
import { getAssessments } from "@/api/assessment";
import PracticepreDialog from "@/components/Teaching/practicepreDialog.vue";
export default {
    components: { Header, modeHeader, studentBG, firstBox, PracticepreDialog },
    data() {
        return {
            modeHeaderId: true,
            isFirst: false,
            // isAssessment:false,
            grades: [],
            detail: {},
            assessmentId: null,
            url: "web-desktop/index.html",
            teachingSwitch: false,
            showDate: null,
        };
    },
    mounted() {
        this.initial();
    },
    watch: {
      $route: {
        handler(to, from) {
          // 关键：先判断 from 是否存在，再访问其属性
          // 只有当 from 存在（即不是页面刷新或首次加载）时，才执行路径判断逻辑
          if (from && from.path !== '/studentAccount'
              && from.path !== '/libraryMode'
              && from.path !== '/testMode'
              && from.path !== '/examination'
              && from.path !== '/answerResult'
              && from.path !== '/selectSubscribed'
              && from.path !== '/help'
              && from.path !== '/examinationAnswerResult'
              && to.path === '/adventure') {
            window.sessionStorage.isLoaded = "true";
          }
        },
        immediate: true, // 保持 immediate: true 是正确的，因为你需要在组件加载时就根据路由状态设置 isLoaded
      }
    },
    methods: {
        showTeaching(data) {
            this.teachingSwitch = true;
            this.showDate = data;
        },
        initial() {
          this.getProfile(true);
          if(this.detail.studying==1){
            this.url="web-desktop-en/index.html";
          }
            window.addEventListener("message", (item) => {
                this.changeRoute(item.data);
            });
            window.onstorage = (e) => {
                if (e.key == "vuex" && this.$route.path == "/adventure") {
                    let gradeId = JSON.parse(e.newValue).studentProgramme.currentGradeId;
                    this.$refs.modeHeader.getGrade(gradeId);
                }
            };
            window.addEventListener("beforeunload", () => {
                window.sessionStorage.isLoaded = "false";
            });
        },
        getProfile(isInitial) {
            this.detail = getUserInfo("userProfile");
            if (isInitial) {
                if (!this.detail.avatar) this.isFirst = true;
                this.getAssessments(this.detail.subscriptions[this.detail.subscriptionIndex].gradeId);
            }
        },
        getAssessments(id) {
            getAssessments({ gradeId: id }).then((v) => {
                if (!v.data.isSkip && v.data.answerResult.length == 0) this.$router.push({ path: `/assessment?gradeId=${id}` });
            });
        },
        deliverToken() {
            this.$nextTick(() => {
                let obj = this.$refs.iframe.contentWindow;
                // obj.document.querySelector("h1.header").remove();
                // obj.document.querySelector("p.footer").remove();
                obj.document.body.style.cssText = "background:none;height:100vh;width:100vw;";
                if (this.$store.getters.isPC) {
                    obj.document.getElementById("GameDiv").style.cssText =
                        "border:none;box-shadow:none;width:auto;height:auto;max-width:100vw;max-height:100vh;aspect-ratio:16/9;margin:auto;position:absolute;top:0;bottom:0;left:0;right:0;";
                } else if (window.innerWidth / (window.innerHeight - 72) <= 16 / 9) {
                    obj.document.getElementById("GameDiv").style.cssText = "border:none;box-shadow:none;width:100vw;height:56.25vw;margin:auto;position:absolute;top:0;bottom:0;left:0;right:0;";
                } else {
                    obj.document.getElementById("GameDiv").style.cssText = `border:none;box-shadow:none;height:100vh;width:${1600 / 9}vh;margin:auto;position:absolute;top:0;bottom:0;left:0;right:0;`;
                }
            });
        },
        changeRoute(data) {
          if (data.type && data.type == "router") {
            let targetPath = "";
            let query = {};

            switch (data.info) {
              case "library":
                targetPath = "/libraryMode";
                break;
              case "homework":
                targetPath = "/testMode";
                break;
              case "assessment": {
                let vuexData = JSON.parse(sessionStorage.getItem("vuex")) || {};
                let currentGradeId = vuexData.studentProgramme?.currentGradeId || 0;
                targetPath = "/assessment";
                query = { gradeId: currentGradeId };
                break;
              }
              case "examination":
                targetPath = "/examination";
                query = {
                  type: 'adventure',
                  topicId: data.topicsId,
                  id: data.id,
                  gradeId: this.$store.getters.currentGradeId,
                  isSmallTest: data.isSmallTest
                };
                break;
              default:
                // 如果没有匹配的 case，直接返回
                return;
            }

            // 核心优化：判断当前路由是否与目标路由一致
            // this.$route.path 只包含路径部分，不包含查询参数
            if (this.$route.path === targetPath) {
              // 如果路径相同，可以选择：
              // 1. 不做任何事（保持现状）
              // 2. 刷新当前页面的数据
              console.log(`已经在 ${targetPath} 页面，无需跳转。`);

              // 示例：如果是作业页面，可以在这里调用刷新作业列表的方法
              if (targetPath === '/testMode') {
                // this.fetchHomeworkList(); // 假设你有一个刷新数据的方法
              }

              return; // 终止函数执行，不再进行 push
            }

            // 如果路径不同，则执行跳转
            this.$router.push({ path: targetPath, query: query }).catch((err) => {
              // 即使做了判断，保留 catch 仍然是一个好习惯，以防其他未知错误
              console.log(err);
            });
          }

          if (data.type && data.type == "upgradation" && data.info == "assessment") {
            this.upgradation();
          }
          if (data.type && data.type == "videoPup") {
            this.showTeaching(data);
          }
        },
        upgradation() {
            getProfile().then((v) => {
                this.detail = JSON.parse(JSON.stringify(v.data));
                // let now = new Date().getTime();
                // this.detail.subscriptionIndex = this.detail.subscriptions.findIndex((item) => {
                //     return new Date(item.startDate).getTime() < now && new Date(item.endDate).getTime() > now;
                // });
                this.detail.subscriptionIndex = 0
                setUserInfo("userProfile", this.detail);
                this.$set(this.detail, "subscriptions", v.data.subscriptions);
                this.gradeChange(this.detail.subscriptions[this.detail.subscriptionIndex].gradeId, true);
                this.$nextTick(() => {
                    this.$refs.modeHeader.getGrade(this.detail.subscriptions[this.detail.subscriptionIndex].gradeId);
                });
            });
        },
        reload() {
            window.sessionStorage.isLoaded = "false";
            let frameWindow = this.$refs.iframe.contentWindow;
            frameWindow.location.reload();
        },
        gradeChange(gradeId, bool) {
            let obj = this.$refs.iframe.contentWindow;
            let params = {
                type: "gradeChange",
                gradeId: gradeId,
            };
            obj.postMessage(params, "*");
            setTimeout(() => {
                if (bool) this.$router.push({ path: `/assessment?gradeId=${gradeId}` }).catch((err) => console.log(err));
                // this.$router.push({ path: `/assessment?gradeId=${this.$store.getters.currentGradeId}` }).catch(err=>console.log(err))
            }, 200);
        },
    },
};
</script>

<style lang="scss" scoped>
.notAdventure {
    position: absolute;
    top: -100vh;
}
.content {
    min-height: 100% !important;
    display: flex;
    flex-direction: column;
}
.contain {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    position: relative;
}
.student-programme-box {
    padding: 3.75rem 8.75rem;
    padding-bottom: 14.5rem;
}
.grid-content-img-box {
    position: relative;
    width: 100%;
    padding-top: 100%;
}
.student-programme-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 2.6875rem;
}
.student-programme-title {
    font-size: 3rem;
    margin-bottom: 1.875rem;
    font-weight: bold;
}
.student-programme-select {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    height: 4.6875rem;
    background-color: #fff;
    border-radius: 1.5rem;
    padding: 0 1.75rem;
}
.student-programme-content {
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 26.25rem;
}
.student-programme-item {
    width: calc(33% - 2.25rem);
    padding: 0.925rem;
    background-color: #ffefae;
    border-radius: 2.6875rem;
    margin-top: 1.25rem;
    margin-left: 1.125rem;
    margin-right: 1.125rem;
}

.student-programme-item-information {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}
.student-programme-item-text {
    margin-top: 0.625rem;
    margin-left: 1.25rem;
    line-height: 2.5rem;
}
.student-programme-item-back {
    position: absolute;
    bottom: 0.75rem;
    right: 0;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
}
.student-programme-item-back-img {
    width: 1.25rem;
}
.student-programme-item-text-title {
    font-weight: bold;
    font-size: 1.25rem;
}
.student-programme-item-back {
    margin-right: 1.25rem;
}
.student-programme-phone {
    display: none;
}
.order-by-ph {
    display: none;
}

.student-programme-content-box {
    display: flex;
}
.student-programme-content-text {
    margin-left: 1.25rem;
}
.student-programme-content-text > div {
    margin-bottom: 1.5625rem;
}
.programme-detail-box-icon {
    width: 5rem;
    height: 5rem;
}
.student-programme-content-text div:first-child {
    font-size: 32px;
    display: flex;
    align-items: center;
    font-weight: bold;
}
.programme-item {
    margin-bottom: 20px;
}
::v-deep {
    .el-divider--vertical {
        //height: 4.6875rem;
        background-color: #e3e3e3;
    }
}
@media (min-width: $minWidth) and (max-width: $maxWidth) {
    .student-programme-box {
        padding: 2.75rem 4.75rem;
    }
    .student-programme-select {
        padding: 0 0.75rem;
    }
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
    .security-box {
        height: 100%;
    }
    .student-programme-box {
        padding: 1.25rem;
        margin-bottom: 20.3125rem;
    }
    .order-by-pc {
        display: none;
    }
    .order-by-ph {
        display: block;
    }
    .student-programme-title {
        flex-direction: column;
        align-items: flex-start;
        font-size: 2.125rem;
    }
    .student-programme-student-programme-img {
        display: none;
    }
    .student-programme-phone {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin-bottom: 0.625rem;
    }
    .student-programme-phone-text {
        font-size: 1.625rem;
        font-weight: bold;
    }
    .student-programme-phone img {
        width: 6.25rem;
    }
    .student-programme-select {
        flex-direction: column;
        width: 100%;
    }
    .student-programme-select .el-divider {
        display: none;
    }
    .student-programme-item {
        width: 100%;
        margin-left: 0;
        margin-right: 0;
    }
    .student-programme-item-back-img {
        width: 2.5rem;
    }
    ::v-deep {
        .el-progress__text {
            font-weight: bold;
        }
    }
}
</style>
